<template>
  <div @click="$refs.menuBar.showTabOper = false" v-if="menuData.length">
    <menu-bar
      v-if="menuInit"
      ref="menuBar"
      :homeObj="homeObj"
      @switchLeftSide="switchLeftSide"
    ></menu-bar>
    <div
      class="home-content"
      :class="{
        'left-home-content': !MENUCONFIG.STYLE.isTop,
        'left-home-big': leftSideHide,
        'has-not-tab': !MENUCONFIG.STYLE.isTab,
      }"
    >
      <div class="page-content">
        <transition name="fade" mode="out-in">
          <keep-alive :include="cachedViews" v-if="MENUCONFIG.STYLE.isTab">
            <router-view />
          </keep-alive>
          <router-view v-else />
        </transition>
      </div>
      <!-- <footer-common></footer-common> -->
    </div>
    <eleSign ref="homeEleSign" @ok="handleOk"></eleSign>
    <aprvStatusDialog ref="aprvStatusDialog"></aprvStatusDialog>
    <userService
      ref="userService"
      :fileId.sync="signList[userServiceIndex]"
      @ok="userServiceOk"
    ></userService>
    <a-modal v-model="isCFCAShow" title="使用CFCA电子签约服务的告知同意内容" :footer="null" width="80%" :closable="false" :keyboard="false" :maskClosable="false">
        
    <CFCA ref="CFCA" v-if="isCFCAShow" @ok="handleOk"></CFCA>
    
    </a-modal>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import menuBar from "@/components-frame/menu/menu-bar";
import CFCA from "@/components-frame/CFCA.vue";
import footerCommon from "@/components-frame/footer";
import eleSign from "@/components/sign/eleSign";
import aprvStatusDialog from "@/components/aprv-status/aprv-status-dialog";
import userService from "@/components/sign/user-service";
export default {
  name: "home",
  data() {
    return {
      homeObj: this,
      pageName: "我是首页",
      leftSideHide: false,
      menuInit: false,
      signList: [],
      userServiceIndex: null,
      isCFCAShow:false,
      cfcaShowNum:0
    };
  },
  components: {
    CFCA,
    menuBar,
    footerCommon,
    eleSign,
    aprvStatusDialog,
    userService,
  },
  computed: {
    ...mapGetters({
      sessionData: "home/getSessionData",
      getUserObj: "home/getUserObj",
      menuData: "home/getMenuData",
      cachedViews: "home/getCachedViews",
    }),
  },
  mounted() {
    this.getHeaderAsync();
    this.menuInit = true;

    if (this.sessionData.createUser === "1") {
      if(!['1','2'].includes(this.getUserObj.status)){
        this.$refs.aprvStatusDialog.open(1);
        return false;
      }
      
    } else {
      if (this.getUserObj.aprvStCd == "0" || this.getUserObj.aprvStCd == "3") {
        //待处理、认证核审中-去认证管理页面
        this.MENUAPI.goToOneTab({
          path: "security/vertify-management",
        });
      } else if (this.getUserObj.aprvStCd == "2") {
        //认证未通过-去静态认证页面
        this.MENUAPI.goToOneTab({
          path: "security/vertify",
        });
      } else if (!this.getUserObj.aprvStCd) {
        //未认证-打开未实名认证弹窗-点击去认证-静态认证填写信息
        this.$refs.aprvStatusDialog.open(2);
        return;
      } else if (this.getUserObj.aprvStCd == "1") {
        //认证通过
        if (this.getUserObj.verifyStCd == null || this.getUserObj.verifyStCd == "0") {
          //判断电子签章签署
          this.$refs.homeEleSign.open();
        } else if (this.getUserObj.signFileMap) {
          //判断用户协议是否签署
          for (let key in this.getUserObj.signFileMap) {
            if (this.getUserObj.signFileMap[key] == "0") {
              this.signList.push(key);
            }
          }
          if (this.signList.length > 0) {
            this.userServiceIndex = 0;
            this.$refs.userService.open();
          }
        }
      }
    }
    // this.handleOk();
  },
  methods: {
    ...mapActions({
      getPermissonAsync: "home/getPermissonAsync",
      getHeaderAsync: "home/getHeaderAsync",
    }),
    switchLeftSide(val) {
      this.leftSideHide = val;
    },
    handleOk() {
      //电子签章签署完成-判断用户协议签署情况
      if (this.getUserObj.signFileMap) {

        this.signList = [];
        for (let key in this.getUserObj.signFileMap) {
          if (this.getUserObj.signFileMap[key] == "0") {
            this.signList.push(key);
          }
        }
        
        if (this.signList.length > 0) {
          if(this.cfcaShowNum == 0){
            this.cfcaShowNum++
            this.isCFCAShow = true;
            return
          }
          this.userServiceIndex = 0;
          this.$refs.userService.open();
        }
      }
    },
    userServiceOk() {
      //用户协议签署成功
      this.userServiceIndex++;
      if (this.signList[this.userServiceIndex]) {
        setTimeout(() => {
          this.$refs.userService.open();
        }, 1000);
      }
    },
  },
  watch: {},
};
</script>

<style scoped>
.home-content {
  height: calc(100vh - 97px);
  overflow: auto;
  display: flex;
  flex-direction: column;
}
.left-home-content {
  position: absolute;
  left: 200px;
  top: 90px;
  right: 0;
  transition: all 0.3s ease;
}
.page-content {
  flex: 1 0 auto;
  padding: 20px;
  background-color: #f5f9fb;
  min-height: calc(100vh - 60px);
  position: relative;
  overflow: hidden;
}
.has-not-tab {
  top: 57px;
  height: calc(100vh - 60px);
}
.left-home-big {
  left: 80px;
}

.fade-enter {
  opacity: 0;
  transform: translate(0, 5px);
}
.fade-leave {
  opacity: 1;
  transform: translate(0, 0);
}
.fade-enter-active {
  transition: all ease 0.4s;
}
</style>


// WEBPACK FOOTER //
// src/components-frame/home.vue